import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactTooltip from 'react-tooltip';

export const StaffbaseSettings = styled.div({
    display: 'flex',
    flexDirection: 'column',
    width: 180,
    margin: '0 auto',
    paddingTop: 12,
});

export const Header = styled.div({
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: 12,
    fontWeight: 600,
    letterSpacing: '1px',
    marginBottom: 8,
    position: 'relative',
    width: '100%',
});

interface IText {
    align?: 'left' | 'center' | 'right';
}

export const Text = styled.p<IText>(({ align }) => ({
    fontSize: 13,
    lineHeight: '20px',
    margin: '8px 0',
    textAlign: align || 'center',
}));

export const TitleText = styled.p<IText>(({ align }) => ({
    fontSize: 13,
    lineHeight: '24px',
    textAlign: align || 'center',
    fontWeight: 600,
}));

export const FooterText = styled.p(({ theme }) => ({
    color: theme.colors.neutral700,
    fontSize: 11,
    lineHeight: '16px',
    marginTop: 8,
    padding: 4,
    textAlign: 'center',
}));

interface IPostCard {
    isDragging: boolean;
}

export const PostCard = styled.div<IPostCard>(({ isDragging, theme }) => ({
    borderRadius: 4,
    border: `1px solid ${theme.colors.neutral100}`,
    boxSizing: 'border-box',
    cursor: 'grab',
    display: 'flex',
    flexDirection: 'column',
    margin: '8px 0',
    transition: '250ms',
    width: '100%',
    opacity: isDragging ? 0.2 : 1,
    ':hover': {
        border: `1px solid ${theme.colors.primary300}`,
    },
}));

export const PostCardHeader = styled.div(({ theme }) => ({
    backgroundColor: theme.colors.neutral000,
    boxSizing: 'border-box',
    borderTopRightRadius: 4,
    borderTopLeftRadius: 4,
    display: 'flex',
    flexDirection: 'column',
    padding: 8,
    width: '100%',
}));

export const PostCardBody = styled.div({
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'space-between',
    padding: 8,
    width: '100%',
});

export const ThumbnailImage = styled.img({
    marginLeft: 4,
    height: 32,
    width: 46,
});

export const ChannelName = styled.p(({ theme }) => ({
    color: theme.colors.neutral900,
    fontSize: 11,
    fontWeight: 600,
    lineHeight: '16px',
}));

export const PublishedDate = styled.p(({ theme }) => ({
    color: theme.colors.neutral700,
    fontSize: 11,
    fontWeight: 400,
    lineHeight: '18px',
    textTransform: 'uppercase',
}));

export const PreviewTitle = styled.p(({ theme }) => ({
    color: theme.colors.neutral900,
    fontSize: 13,
    lineHeight: '16px',
    maxWidth: 112,
    hyphens: 'auto',
    wordWrap: 'break-word',
}));

export const Languages = styled.div({
    display: 'flex',
    padding: '0 8px',
    width: '100%',
    flexWrap: 'wrap',
});

interface ILanguageProps {
    selected: boolean;
}

export const Language = styled.div<ILanguageProps>(({ theme, selected }) => ({
    color: selected ? theme.colors.primary300 : theme.colors.neutral900,
    fontSize: 11,
    lineHeight: '18px',
    letterSpacing: '0.5px',
    borderBottom: selected ? `1px solid ${theme.colors.primary300}` : 'none',
    fontWeight: 700,
    ':hover': {
        color: theme.colors.primary300,
    },
}));

export const PostReactTooltip = styled(ReactTooltip)({
    borderBottom: '6px solid #222',
    borderTop: '6px solid #222',
    padding: '6px 14px !important',
});

export const PostTooltipDiv = styled.div({
    border: 0,
    padding: 0,
    width: 206,
});

export const PostTooltipText = styled.p({
    fontSize: 11,
    fontStyle: 'normal',
    fontWeight: 'normal',
    letterSpacing: '0.2px',
    lineHeight: '16px',
});

export const LockIcon = styled(FontAwesomeIcon)({
    fontSize: 12,
});

export const SlidersIcon = styled(FontAwesomeIcon)({
    marginRight: 4,
    fontSize: 12,
});

export const PreferencesButton = styled.button(({ theme }) => ({
    color: theme.colors.primary300,
    border: 'none',
    outline: 'none',
    background: 'none',
    cursor: 'pointer',
    margin: '8px 0',
    fontWeight: 600,
    fontSize: 11,
}));

export const Notifier = styled.div(({ theme }) => ({
    backgroundColor: theme.colors.pastelPrimary300,
    padding: 8,
    fontSize: 11,
    lineHeight: '16px',
    margin: '10px 0',
}));

export const PreferencesActionButtonsWrapper = styled.div({
    display: 'flex',
    justifyContent: 'space-between',
});

export const Input = styled.input({
    border: 'none',
    marginLeft: 4,
    outline: 'none',
});

export const ErrorText = styled.p(({ theme }) => ({
    color: theme.colors.danger700,
    fontSize: 11,
    lineHeight: '16px',
    width: '105%',
}));

export const InstructionsLink = styled.a(({ theme }) => ({
    color: theme.colors.primary300,
    textDecoration: 'none',
    ':hover': {
        textDecoration: 'underline',
        color: theme.colors.primary700,
    },
    ':visited': {
        color: theme.colors.primary300,
    },
}));

interface ISbRightPanelDiv {
    isText: boolean;
}

export const SbRightPanelDiv = styled.div<ISbRightPanelDiv>`
    width: 250px;
    height: 100%;
    background-color: white;
    position: relative;
    user-select: none;
    overflow-y: ${({ isText }) => (isText ? 'visible' : 'scroll')};
`;

interface ILoadingWrapperDiv {
    postsLength: Number;
}

export const LoadingWrapper = styled.div<ILoadingWrapperDiv>`
    display: flex;
    justify-content: center;
    margin-top: ${({ postsLength }) => (postsLength > 0 ? 0 : 60)}px;
`;
